module.exports = __webpack_public_path__ + "media/images/nav/icon_16-5d9125ffd578b0f0ff3cc669b8c90c75.svg";